import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import { loginUser, socialLogin } from "../../store/actions"

import profile from "assets/images/profile-img.png"
import logo from "assets/images/logo.svg"
import { loginreq } from "helpers/requests"

const Login = props => {
  document.title = "Login"
  const dispatch = useDispatch()
  
  const [err,setErr]= useState(null)
 
  useEffect(() => {
    const token = localStorage.getItem("auth")
    if (token) {
      
      window.location.href='/'
    }
  }, [])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "protour@gmail.com" || '',
      password: "12345678" || '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
      try {
       
    
        // Await the login request
        const res = await loginreq(values)
       
    
        if (res?.token) {
          const expirationTime = new Date().getTime() + 2 * 60 * 60 * 1000
          localStorage.setItem("auth", res.token)
          localStorage.setItem("auth_expiration", expirationTime)
          localStorage.setItem("role",res.role)
          localStorage.setItem("username",res.username)
          
          window.location.href = '/'
    
          // Optionally, you can also dispatch the login action if needed
          dispatch(loginUser(values, props.router.navigate))
        } else {
          // If no token is returned, show an error message
          dispatch({ type: "LOGIN_FAILURE", payload: "Wrong credentials" })
        }
      } catch (error) {
        // Check if the error has a response and a status
        const errorMessage = error.response?.data?.message || error.message || "Something went wrong"
        setErr(errorMessage)

        setTimeout(() => {
          setErr(null)
        }, 3000)
        dispatch({ type: "LOGIN_FAILURE", payload: errorMessage })
      }
    }
    
    
  })

  const LoginProperties = createSelector(
    (state) => state.Login,
    (login) => ({
      error: login.error
    })
  )

  const { error } = useSelector(LoginProperties)

  const signIn = type => {
    dispatch(socialLogin(type, props.router.navigate))
  }

  const socialResponse = type => {
    signIn(type)
  }

  useEffect(()=>{console.log(error?.response?.status)},[error])

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to Protour Dashboard.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="logo-light-element">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      {err ? <Alert color="danger">{err}</Alert> : null}

                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.password && validation.errors.password ? true : false
                          }
                        />
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                        >
                          Log In
                        </button>
                      </div>

               

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
             {/*  <div className="mt-5 text-center">
                <p>
                  Don&#39;t have an account ?{" "} <Link to="/register" className="fw-medium text-primary">
                    {" "}
                    Signup now{" "}
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Skote. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Themesbrand
                </p>
              </div>
              */}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}

